<template>
  <div id="app">
    <navbar></navbar>
    <div class="main py-5">
      <router-view />
    </div>
    <custom-footer></custom-footer>
  </div>
</template>

<script>
import CustomFooter from "./components/CustomFooter.vue";
import Navbar from "./components/Navbar.vue";

export default {
  name: "App",
  components: {
    CustomFooter,
    Navbar
  }
};
</script>

<style lang="scss" scoped>
#app {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.main {
  flex: 1 0 auto;
}
</style>
